<header class="header" [ngClass]="{'scrolled': isScrolled}" id="main-header">
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container-wide" style="display: flex; width: 100%;">
      <a class="navbar-brand" href="#" style="margin-left: 5%;">
        <!-- <div class="logo-wrapper">
          <div class="logo-container">
            <div class="logo-text">Relay</div>
            <div class="logo-tagline">AI Powered</div>
          </div>
        </div> -->
        <img src="/assets/images/new-home/relay-logo.png" alt="Logo" class="logo" style="width: 20vh; height: 8vh;">
      </a>
      <button class="navbar-toggler" type="button" (click)="toggleMenu()">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" style="margin-right: 5%;" [ngClass]="{'show': !isMenuCollapsed}">
        <ul class="navbar-nav ml-auto" *ngIf="isAuthenticated">
          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('functional')}"
              (mouseenter)="onMouseEnter('functional')" (mouseleave)="onMouseLeave('functional')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault()" routerLink="/overview" id="nav-overview" [class.active]="isRouteActive(['/overview'])">
              <i class="fas fa-cogs menu-icon"></i><span>Functional</span>
            </a>
            <div class="dropdown-menu" [ngClass]="{'show': isDropdownActive('functional')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom" routerLink="/overview" id="nav-overview" [class.active]="isRouteActive(['/overview'])">Overview</a>
                <a class="dropdown-item-custom" routerLink="/endpoint" [queryParams]="{ page: 1, size: 15 }" id="nav-endpoint" [class.active]="isRouteActive(['/endpoint'])"> Endpoint</a>
                <a class="dropdown-item-custom" routerLink="/testcase" [queryParams]="{ page: 1, size: 15 }" id="nav-testcase" [class.active]="isRouteActive(['/testcase'])"> Testcase</a>
                <a class="dropdown-item-custom" routerLink="/testsuite" [queryParams]="{ page: 1, size: 15 }" id="nav-testsuite" [class.active]="isRouteActive(['/testsuite'])"> Testsuite</a>
                <a class="dropdown-item-custom" routerLink="/mastersuite" [queryParams]="{ page: 1, size: 15 }" id="nav-mastersuite" [class.active]="isRouteActive(['/mastersuite'])">Mastersuite</a>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('mobile')}"
              (mouseenter)="onMouseEnter('mobile')" (mouseleave)="onMouseLeave('mobile')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault()" routerLink="/mobileAutomation/overview" id="nav-mobile-overview">
              <i class="fas fa-mobile-alt menu-icon"></i><span>Mobile</span>
            </a>
            <div class="dropdown-menu" [ngClass]="{'show': isDropdownActive('mobile')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom" routerLink="/mobileAutomation/overview" id="nav-mobile-overview">Overview</a>
                <a class="dropdown-item-custom d-flex" routerLink="/mobileAutomation/locator" [queryParams]="{ platformType: 'MOBILE' }" id="nav-mobile-locator"><span>Locator</span></a>
                <a class="dropdown-item-custom d-flex" routerLink="/mobileAutomation/instruction" [queryParams]="{ platformType: 'MOBILE' }" id="nav-chaos-instruction"> <span>Instructions</span></a>
                <a class="dropdown-item-custom d-flex" routerLink="/mobileAutomation/executions" [queryParams]="{ platformType: 'MOBILE' }" id="nav-chaos-execution"> <span>Executions</span></a>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('desktop')}"
              (mouseenter)="onMouseEnter('desktop')" (mouseleave)="onMouseLeave('desktop')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault()" routerLink="/desktopAutomation/overview" id="nav-chaos-overview">
              <i class="fas fa-desktop menu-icon"></i><span>Desktop</span>
            </a>
            <div class="dropdown-menu" [ngClass]="{'show': isDropdownActive('desktop')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom" routerLink="/desktopAutomation/overview" id="nav-chaos-overview">Overview</a>
                <a class="dropdown-item-custom d-flex" routerLink="/desktopAutomation/locator" [queryParams]="{ platformType: 'DESKTOP' }" id="nav-desktop-locator"><span>Locator</span></a>
                <a class="dropdown-item-custom d-flex" routerLink="/desktopAutomation/instruction" [queryParams]="{ platformType: 'DESKTOP' }" id="nav-desktop-instruction"> <span>Instruction</span></a>
                <a class="dropdown-item-custom d-flex" routerLink="/desktopAutomation/executions" [queryParams]="{ platformType: 'DESKTOP' }" id="nav-desktop-execution"> <span>Executions</span></a>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('performance')}"
              (mouseenter)="onMouseEnter('performance')" (mouseleave)="onMouseLeave('performance')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault()" routerLink="/performance" id="nav-chaos-overview">
              <i class="fas fa-tachometer-alt menu-icon"></i><span>Performance Lab</span>
            </a>
            <div class="dropdown-menu" [ngClass]="{'show': isDropdownActive('performance')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom" routerLink="/performance" id="nav-chaos-overview"> Overview</a>
                <a class="dropdown-item-custom d-flex" routerLink="/performance/loadTesting" id="nav-chaos-started"> Test
                  Manager</a>
                <a class="dropdown-item-custom" routerLink="/performance/loadTesting/queue" [queryParams]="{ page: 1, size: 15 }" id="nav-chaos-overview"> Test Results</a>
                <a class="dropdown-item-custom d-flex" routerLink="/performance/loadTesting/compare" id="nav-chaos-started">
                  <span> Review Testability Comparison </span></a>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('chaos')}"
              (mouseenter)="onMouseEnter('chaos')" (mouseleave)="onMouseLeave('chaos')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault()" routerLink="/chaos/overview" id="nav-chaos-overview">
              <i class="fas fa-random menu-icon"></i><span>Chaos Simulator</span>
            </a>
            <div class="dropdown-menu" [ngClass]="{'show': isDropdownActive('chaos')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom" routerLink="/chaos/overview" id="nav-chaos-overview"> Overview</a>
                <a class="dropdown-item-custom d-flex" routerLink="/chaos/intermediate" id="nav-chaos-started"> <span>Getting started</span></a>
              </div>
            </div>
          </li>

          <li class="nav-item ai-features-item" *ngIf="router.url.includes('/home')">
            <a class="nav-link" href="#ai-features" (click)="scrollToSection('ai-features'); $event.preventDefault();">
              <i class="fas fa-brain menu-icon"></i><span>AI&nbsp;Features</span>
            </a>
          </li>

          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('more')}" (mouseenter)="onMouseEnter('more')" (mouseleave)="onMouseLeave('more')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault();">
              <i class="fas fa-history menu-icon"></i><span>Execution History</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" [ngClass]="{'show': isDropdownActive('more')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom" routerLink="/history/testcase" id="nav-history-testcase" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_CASE' }" [class.active]="isRouteActive(['/history/testcase', '/results/testcase'])">
                  Test Case</a>
                <a class="dropdown-item-custom" routerLink="/history/testsuite" id="nav-history-testsuite" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_SUITE' }" [class.active]="isRouteActive(['/history/testsuite', '/results/testsuite'])">
                  Test Suite</a>
                <a class="dropdown-item-custom" routerLink="/history/mastersuite" id="nav-history-mastersuite" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'MASTER_SUITE' }" [class.active]="isRouteActive(['/history/mastersuite', '/results/mastersuite'])">
                  Master Suite</a>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown-wrapper" [ngClass]="{'active': isDropdownActive('welcome')}" (mouseenter)="onMouseEnter('welcome')" (mouseleave)="onMouseLeave('welcome')">
            <a class="nav-link dropdown-toggle" href="#" (click)="$event.preventDefault(); toggleDropdown('welcome')">
              <i class="fas fa-user menu-icon"></i><span class="user-name">{{ userName }} <i class="fas fa-chevron-down"></i></span>
            </a>
            <div class="dropdown-menu" [ngClass]="{'show': isDropdownActive('welcome')}">
              <div class="dropdown-menu-inner">
                <a class="dropdown-item-custom d-flex" routerLink="/user" id="nav-user" routerLinkActive="active"><i class="fas fa-user menu-icon-dropdown"></i> User </a>
                <a class="dropdown-item-custom d-flex" routerLink="/help" id="nav-help" routerLinkActive="active"><i class="fas fa-video menu-icon-dropdown"></i> Demo Videos</a>
                <a class="dropdown-item-custom" routerLink="/help/help-center" id="nav-help-center" [class.active]="isRouteActive(['/help-center'])"> <i class="fas fa-question-circle menu-icon-dropdown"></i> Help Center</a>
                <a class="dropdown-item-custom" href="https://app.powerbi.com/groups/me/apps/2ef02564-a5c1-44c0-a05d-1fd7f6233cbf/reports/172e817a-49f2-4ed2-bf3b-58fd0b5e72de/ReportSectionc5ad66c9e48ee2282238?chromeless=true" target="_blank"> <i class="fas fa-chart-line menu-icon-dropdown"></i>Dashboard</a>
                <a class="dropdown-item-custom" id="nav-signout" (click)="logout()"> <i class="fas fa-sign-out-alt menu-icon-dropdown"></i>Sign out</a>
              </div>
            </div>

          </li>
          <div class="user-welcome ml-3 dropdown-menu dropdown-menu-right">
          </div>
        </ul>


        <ul class="navbar-nav ml-auto" *ngIf="!isAuthenticated">
          <li class="nav-item mr-2">
            <a class="nav-link" href="#relay/help" class="btn btn-outline-light">Demo Videos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="login()" id="nav-home" routerLinkActive="active" class="btn btn-sign-in mr-3"> <i class="fas fa-sign-in-alt mr-1"></i>Sign In</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
